import * as React from 'react';
const SvgCalendarCross = (props) => (
  <svg
    width={17}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.91504 6.00004H14.6579M6.17694 1.33337V3.33337M11.396 1.33337V3.33337M5.52456 14.6667H12.0484C13.4896 14.6667 14.6579 13.4728 14.6579 12V5.00004C14.6579 3.52728 13.4896 2.33337 12.0484 2.33337H5.52456C4.08336 2.33337 2.91504 3.52728 2.91504 5.00004V12C2.91504 13.4728 4.08336 14.6667 5.52456 14.6667Z"
      stroke="#28303F"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 8L7 12M7 8L11 12"
      stroke="#29292B"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgCalendarCross;
